<template>
	<tr>
		<td class="drag-handle" style="cursor: grab">
			<i class="fas fa-grip-lines"></i>
		</td>
		<td>
			<div>#{{ position }}</div>
		</td>
		<td>
			<div>{{ course.title }}</div>
		</td>
		<td class="text-center">
			<div v-if="course.isOnline">
				<span class="badge bg-primary">Online</span>
			</div>
			<div v-else><span class="badge bg-info">Presencial</span></div>
		</td>
		<td>
			<div v-if="course.enabled"><span class="badge bg-success">Activo</span></div>
			<div v-else><span class="badge bg-danger">Inactivo</span></div>
		</td>
		<td class="text-center">
			<router-link
				class="btn btn-sm btn-outline-dark m-1"
				:key="course"
				:to="{ name: 'SingleCourseView', params: { courseUUID: course.UUID } }"
				><i class="fas fa-eye"></i
			></router-link>
			<button class="btn btn-sm btn-outline-danger m-1" @click="deleteCourse()">
				<i class="fas fa-trash"></i>
			</button>
		</td>
	</tr>
</template>

<script>
import CourseService from "../../services/course.service";

import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import Swal from "sweetalert2";

export default {
	name: "CourseRow",
	components: {
		QuillEditor,
	},
	props: {
		course: Object,
		position: Number,
	},
	data() {
		return {
			id: this.course.UUID,
		};
	},
	methods: {
		async deleteCourse() {
			// 1. Ask for confirmation
			const result = await Swal.fire({
				title: '¿Quieres confirmar esta acción?',
				text: `Vas a eliminar el curso: ${this.course.title}`,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#d33',
				cancelButtonColor: '#3085d6',
				confirmButtonText: 'Sí, borrar',
				cancelButtonText: 'Cancelar'
			});

			// 2. Check if the user clicked "confirm"
			if (result.isConfirmed) {
				try {
					let response = await CourseService.deleteCourse(this.course.UUID);
					if (response.status == 200 || response.status == 204) {
						Swal.fire({
							position: "top-end",
							icon: "success",
							title: "Se ha borrado correctamente.",
							showConfirmButton: false,
							timer: 1500,
							backdrop: false,
							toast: true,
						});
						setTimeout(() => {
							this.$router.go();
						}, 1500);
					}
				} catch (error) {
					Swal.fire('Error', 'Nose pudo eliminar el curso.', 'error');
				}
			}
		},
	},
};
</script>
